import { reducerWithInitialState } from 'typescript-fsa-reducers';
import { getStatus } from './actions';
import { KansatsuKirokuArchiveStatus } from '../../../models/KansatsuKirokuArchiveStatus';

export interface FullArchiveDownloadObsrecState {
  loaded: boolean;
  item: KansatsuKirokuArchiveStatus;
}

const initialState: FullArchiveDownloadObsrecState = {
  loaded: false,
  item: new KansatsuKirokuArchiveStatus()
};

const reducer = reducerWithInitialState(initialState)
  .case(getStatus.started, (state) => {
    return { ...initialState };
  })
  .case(getStatus.done, (state, param) => {
    const newState = { ...state, loaded: true, item: param.result.Item };
    // ttlは文字列で返ってくるが数値で扱う。値がなければkeyを削除する
    if (newState.item.ttl) {
      newState.item.ttl = Number(newState.item.ttl);
      if (isNaN(newState.item.ttl)) {
        delete newState.item.ttl;
      }
    } else {
      delete newState.item.ttl;
    }
    return newState;
  })


;

export default reducer;


// WEBPACK FOOTER //
// ./src/redux/modules/fullArchiveDownloadObsrec/reducers.ts